module.exports = __webpack_public_path__ + "static/media/vertical_icon.f1ef2ace.svg";